var _path, _g, _g2, _g3, _g4, _path2, _path3, _path4, _g5, _g6, _g7, _g8, _g9, _g10, _rect, _rect2, _rect3, _path5, _path6, _path7, _circle, _path8, _circle2, _path9, _circle3, _path10, _circle4, _path11, _circle5, _path12, _circle6, _path13, _circle7, _path14, _path15, _path16, _rect4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXSellLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 235,
    viewBox: "0 0 286 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M242.077 194.22C235.837 185 228.587 174.05 230.657 162.28C234.167 150.29 242.717 140.23 249.017 129.72C256.457 116.49 250.787 112.09 238.507 107.24C234.287 105.7 228.717 104.85 224.597 103.07C215.597 97.9999 216.377 89.3899 203.537 83.6999C195.427 79.1699 187.757 80.5499 179.347 83.1499C172.367 84.9299 164.737 85.7999 157.547 85.5799C136.897 84.3299 115.937 83.1999 95.2466 83.4999C85.5666 83.7699 74.9066 83.8699 65.5766 86.7199C52.7166 92.3599 42.4366 103.91 41.3066 118.57C40.2366 154.39 60.5266 161.36 55.8366 174.52C51.9666 187.47 48.4366 212.85 61.3266 221.36C72.2866 226.21 95.5366 215.62 109.177 215.67C122.487 214.9 126.537 218 137.647 223.82C150.117 229.49 163.727 232.9 177.307 234.18C197.007 236.24 217.247 233.32 235.797 226.32C255.417 218.35 254.637 209.64 242.077 194.21V194.22Z",
    fill: "#080333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19109_24631)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.2056 32.71L75.1656 31.89L75.0356 31.02L74.8756 30.34L74.7056 29.84L74.4456 29.19L74.1456 28.62L73.6556 27.86L73.1056 27.16L72.5556 26.6L72.0356 26.15L71.5156 25.77L70.9356 25.41L70.3256 25.1L69.7956 24.88L69.2956 24.71L68.5156 24.51L67.9456 24.42L67.4356 24.37L66.8556 24.35L66.4556 24.36L65.8656 24.41L65.3156 24.49L64.7856 24.61L64.3556 24.73L64.0256 24.85L63.6656 24.98L63.3156 25.14L62.9856 25.3L62.6856 25.46L62.2656 25.73L61.8456 26.02L61.5956 26.22L61.4056 26.37L61.1656 26.59L60.8756 26.12L60.4356 25.47L60.0756 25L59.5156 24.35L58.9456 23.78L58.4156 23.29L57.9756 22.95L57.5256 22.62L57.0056 22.27L56.3456 21.88L55.8456 21.62L55.1656 21.32L54.4656 21.05L53.6756 20.81L52.8856 20.63L52.1656 20.51L51.6056 20.45L50.9256 20.4L50.4756 20.39L49.6656 20.42L49.0756 20.47L48.5156 20.55L47.8956 20.66L47.1056 20.86L46.5456 21.03L45.8756 21.28L45.3156 21.52L44.8256 21.76L44.3956 21.99L43.8956 22.29L43.4756 22.58L43.0756 22.86L42.8256 23.06L42.6656 23.19L42.4656 23.35L42.2556 23.53L42.0156 23.11L41.4056 22.16L40.7856 21.31L40.2056 20.59L39.6556 19.98L39.0456 19.35L38.4456 18.79L37.6756 18.13L37.2156 17.77L36.6356 17.35L36.1156 17L35.6056 16.68L35.1156 16.39L34.6356 16.13L33.8656 15.75L33.2856 15.49L32.7556 15.28L32.1556 15.05L31.3756 14.8L30.7456 14.62L30.1056 14.46L29.4856 14.33L28.8156 14.22L28.1756 14.13L27.6156 14.07L26.9856 14.03L26.5156 14H25.9456L25.2856 14.01L24.6956 14.04L24.0856 14.09L23.4856 14.16L22.8856 14.25L22.2656 14.36L21.7056 14.48L21.1356 14.62L20.5356 14.79L19.9556 14.98L19.4756 15.15L18.7056 15.45L18.0856 15.73L17.5756 15.97L17.1056 16.22L16.4256 16.6L16.0156 16.85L15.4756 17.2L15.0256 17.52L14.5256 17.89L13.9956 18.31L13.5156 18.73L12.9556 19.25L12.5056 19.7L12.0356 20.2L11.4656 20.86L10.9856 21.48L10.5956 22.02L10.1856 22.62L9.90563 23.09L9.51562 23.77L9.17562 24.4L8.87563 25.04L8.59563 25.7L8.36563 26.32L8.13563 26.98L7.96562 27.54L7.77562 28.26L7.66563 28.73L7.57563 29.16L7.49563 29.62L7.42562 30.05L7.37562 30.49L7.30562 31.17L7.26562 31.77V32.71H9.33562H75.2056Z",
    fill: "#080333"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19109_24631)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.206 18.71L224.166 17.89L224.036 17.02L223.876 16.34L223.706 15.84L223.446 15.19L223.146 14.62L222.656 13.86L222.106 13.16L221.556 12.6L221.036 12.15L220.516 11.77L219.936 11.41L219.326 11.1L218.796 10.88L218.296 10.71L217.516 10.51L216.946 10.42L216.436 10.37L215.856 10.35L215.456 10.36L214.866 10.41L214.316 10.49L213.786 10.61L213.356 10.73L213.026 10.85L212.666 10.98L212.316 11.14L211.986 11.3L211.686 11.46L211.266 11.73L210.846 12.02L210.596 12.22L210.406 12.37L210.166 12.59L209.876 12.12L209.436 11.47L209.076 11L208.516 10.35L207.946 9.78L207.416 9.29L206.976 8.95L206.526 8.62L206.006 8.27L205.346 7.88L204.846 7.62L204.166 7.32L203.466 7.05L202.676 6.81L201.886 6.63L201.166 6.51L200.606 6.45L199.926 6.4L199.476 6.39L198.666 6.42L198.076 6.47L197.516 6.55L196.896 6.66L196.106 6.86L195.546 7.03L194.876 7.28L194.316 7.52L193.826 7.76L193.396 7.99L192.896 8.29L192.476 8.58L192.076 8.86L191.826 9.06L191.666 9.19L191.466 9.35L191.256 9.53L191.016 9.11L190.406 8.16L189.786 7.31L189.206 6.59L188.656 5.98L188.046 5.35L187.446 4.79L186.676 4.13L186.216 3.77L185.636 3.35L185.116 3L184.606 2.68L184.116 2.39L183.636 2.13L182.866 1.75L182.286 1.49L181.756 1.28L181.156 1.05L180.376 0.8L179.746 0.62L179.106 0.46L178.486 0.33L177.816 0.22L177.176 0.13L176.616 0.07L175.986 0.03L175.516 0H174.946L174.286 0.01L173.696 0.04L173.086 0.09L172.486 0.16L171.886 0.25L171.266 0.36L170.706 0.48L170.136 0.62L169.536 0.79L168.956 0.98L168.476 1.15L167.706 1.45L167.086 1.73L166.576 1.97L166.106 2.22L165.426 2.6L165.016 2.85L164.476 3.2L164.026 3.52L163.526 3.89L162.996 4.31L162.516 4.73L161.956 5.25L161.506 5.7L161.036 6.2L160.466 6.86L159.986 7.48L159.596 8.02L159.186 8.62L158.906 9.09L158.516 9.77L158.176 10.4L157.876 11.04L157.596 11.7L157.366 12.32L157.136 12.98L156.966 13.54L156.776 14.26L156.666 14.73L156.576 15.16L156.496 15.62L156.426 16.05L156.376 16.49L156.306 17.17L156.266 17.77V18.71H158.336H224.206Z",
    fill: "#080333"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_19109_24631)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.947 51L122.927 50.6056L122.865 50.1871L122.788 49.86L122.706 49.6195L122.581 49.3068L122.437 49.0326L122.201 48.667L121.936 48.3303L121.672 48.0609L121.422 47.8445L121.172 47.6617L120.893 47.4885L120.599 47.3394L120.344 47.2336L120.104 47.1518L119.728 47.0556L119.454 47.0123L119.209 46.9882L118.93 46.9786L118.738 46.9834L118.454 47.0075L118.189 47.046L117.934 47.1037L117.727 47.1614L117.569 47.2191L117.396 47.2817L117.227 47.3586L117.068 47.4356L116.924 47.5126L116.722 47.6424L116.52 47.7819L116.4 47.8781L116.308 47.9503L116.193 48.0561L116.053 47.83L115.842 47.5174L115.669 47.2913L115.399 46.9786L115.125 46.7044L114.87 46.4687L114.658 46.3052L114.442 46.1464L114.192 45.9781L113.874 45.7905L113.634 45.6654L113.307 45.5211L112.97 45.3912L112.59 45.2758L112.21 45.1892L111.864 45.1315L111.594 45.1026L111.267 45.0786L111.051 45.0738L110.661 45.0882L110.377 45.1122L110.108 45.1507L109.81 45.2036L109.43 45.2998L109.16 45.3816L108.838 45.5019L108.569 45.6173L108.333 45.7328L108.126 45.8434L107.886 45.9877L107.684 46.1272L107.491 46.2619L107.371 46.3581L107.294 46.4206L107.198 46.4976L107.097 46.5842L106.981 46.3821L106.688 45.9252L106.39 45.5163L106.111 45.17L105.846 44.8765L105.553 44.5735L105.264 44.3041L104.894 43.9866L104.672 43.8135L104.393 43.6114L104.143 43.4431L103.898 43.2892L103.662 43.1497L103.431 43.0246L103.061 42.8418L102.782 42.7167L102.527 42.6157L102.238 42.5051L101.863 42.3848L101.56 42.2982L101.252 42.2213L100.954 42.1587L100.632 42.1058L100.324 42.0625L100.055 42.0337L99.7515 42.0144L99.5254 42H99.2512L98.9337 42.0048L98.6499 42.0192L98.3565 42.0433L98.0679 42.077L97.7793 42.1203L97.481 42.1732L97.2116 42.2309L96.9375 42.2982L96.6488 42.38L96.3698 42.4714L96.139 42.5532L95.7686 42.6975L95.4703 42.8322L95.225 42.9476L94.9989 43.0679L94.6718 43.2507L94.4746 43.3709L94.2149 43.5393L93.9984 43.6932L93.7579 43.8712L93.5029 44.0732L93.272 44.2753L93.0027 44.5254L92.7862 44.7418L92.5601 44.9824L92.2859 45.2998L92.055 45.5981L91.8674 45.8578L91.6702 46.1464L91.5355 46.3725L91.3479 46.6996L91.1844 47.0027L91.0401 47.3105L90.9054 47.628L90.7948 47.9262L90.6841 48.2437L90.6023 48.5131L90.5109 48.8594L90.458 49.0855L90.4147 49.2924L90.3763 49.5136L90.3426 49.7205L90.3185 49.9321L90.2849 50.2592L90.2656 50.5478V51H91.2613H122.947Z",
    fill: "#080333"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_19109_24631)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.947 36L271.927 35.6056L271.865 35.1871L271.788 34.86L271.706 34.6195L271.581 34.3068L271.437 34.0326L271.201 33.667L270.936 33.3303L270.672 33.0609L270.422 32.8445L270.172 32.6617L269.893 32.4885L269.599 32.3394L269.344 32.2336L269.104 32.1518L268.728 32.0556L268.454 32.0123L268.209 31.9882L267.93 31.9786L267.738 31.9834L267.454 32.0075L267.189 32.046L266.934 32.1037L266.727 32.1614L266.569 32.2191L266.396 32.2817L266.227 32.3586L266.068 32.4356L265.924 32.5126L265.722 32.6424L265.52 32.7819L265.4 32.8781L265.308 32.9503L265.193 33.0561L265.053 32.83L264.842 32.5174L264.669 32.2913L264.399 31.9786L264.125 31.7044L263.87 31.4687L263.658 31.3052L263.442 31.1464L263.192 30.9781L262.874 30.7905L262.634 30.6654L262.307 30.5211L261.97 30.3912L261.59 30.2758L261.21 30.1892L260.864 30.1315L260.594 30.1026L260.267 30.0786L260.051 30.0738L259.661 30.0882L259.377 30.1122L259.108 30.1507L258.81 30.2036L258.43 30.2998L258.16 30.3816L257.838 30.5019L257.569 30.6173L257.333 30.7328L257.126 30.8434L256.886 30.9877L256.684 31.1272L256.491 31.2619L256.371 31.3581L256.294 31.4206L256.198 31.4976L256.097 31.5842L255.981 31.3821L255.688 30.9252L255.39 30.5163L255.111 30.17L254.846 29.8765L254.553 29.5735L254.264 29.3041L253.894 28.9866L253.672 28.8135L253.393 28.6114L253.143 28.4431L252.898 28.2892L252.662 28.1497L252.431 28.0246L252.061 27.8418L251.782 27.7167L251.527 27.6157L251.238 27.5051L250.863 27.3848L250.56 27.2982L250.252 27.2213L249.954 27.1587L249.632 27.1058L249.324 27.0625L249.055 27.0337L248.751 27.0144L248.525 27H248.251L247.934 27.0048L247.65 27.0192L247.356 27.0433L247.068 27.077L246.779 27.1203L246.481 27.1732L246.212 27.2309L245.937 27.2982L245.649 27.38L245.37 27.4714L245.139 27.5532L244.769 27.6975L244.47 27.8322L244.225 27.9476L243.999 28.0679L243.672 28.2507L243.475 28.3709L243.215 28.5393L242.998 28.6932L242.758 28.8712L242.503 29.0732L242.272 29.2753L242.003 29.5254L241.786 29.7418L241.56 29.9824L241.286 30.2998L241.055 30.5981L240.867 30.8578L240.67 31.1464L240.536 31.3725L240.348 31.6996L240.184 32.0027L240.04 32.3105L239.905 32.628L239.795 32.9262L239.684 33.2437L239.602 33.5131L239.511 33.8594L239.458 34.0855L239.415 34.2924L239.376 34.5136L239.343 34.7205L239.319 34.9321L239.285 35.2592L239.266 35.5478V36H240.261H271.947Z",
    fill: "#080333"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7131 201.612H207.573C213.953 201.612 220.363 201.812 226.743 201.612C226.833 201.612 226.923 201.612 227.013 201.612C228.943 201.612 228.943 198.612 227.013 198.612H88.1531C81.7731 198.612 75.3631 198.412 68.9831 198.612C68.8931 198.612 68.8031 198.612 68.7131 198.612C66.7831 198.612 66.7831 201.612 68.7131 201.612Z",
    fill: "#080333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.01 201.609H247.79C249.72 201.609 249.72 198.609 247.79 198.609H235.01C233.08 198.609 233.08 201.609 235.01 201.609Z",
    fill: "#080333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9084 201.609H60.6884C62.6184 201.609 62.6184 198.609 60.6884 198.609H47.9084C45.9784 198.609 45.9784 201.609 47.9084 201.609Z",
    fill: "#080333"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_19109_24631)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M256.365 78L255.365 84.9701L249.266 86.2185L255.733 87.6125L257.365 94L258.385 87.3004L264.199 85.9896L258.222 85.0325L256.365 78Z",
    fill: "#795AF7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_19109_24631)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M255.365 161L254.365 167.97L248.266 169.218L254.733 170.612L256.365 177L257.385 170.3L263.199 168.99L257.222 168.033L255.365 161Z",
    fill: "#795AF7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_19109_24631)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M7.36508 95L6.36544 101.97L0.265625 103.218L6.73266 104.612L8.36471 111L9.38475 104.3L15.199 102.99L9.22155 102.033L7.36508 95Z",
    fill: "#795AF7"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_19109_24631)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M7.36508 180L6.36544 186.97L0.265625 188.218L6.73266 189.612L8.36471 196L9.38475 189.3L15.199 187.99L9.22155 187.033L7.36508 180Z",
    fill: "#795AF7"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_19109_24631)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M18.8154 136L18.3155 139.485L15.2656 140.109L18.4991 140.806L19.3152 144L19.8252 140.65L22.7323 139.995L19.7436 139.516L18.8154 136Z",
    fill: "#795AF7"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_19109_24631)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M281.815 113L281.316 116.485L278.266 117.109L281.499 117.806L282.315 121L282.825 117.65L285.732 116.995L282.744 116.516L281.815 113Z",
    fill: "#795AF7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 100,
    width: 78,
    height: 99,
    rx: 4,
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 157,
    width: 12,
    height: 33,
    rx: 6,
    fill: "#90079E",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 109,
    width: 60,
    height: 18,
    rx: 4,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M160.5 110.5H103.5V116.5H160.5V110.5Z",
    fill: "#080333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M169.5 100H94.5V107.5H169.5V100Z",
    fill: "#080333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M169.646 191.82H93.6094V198.292H169.646V191.82Z",
    fill: "#080333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 142,
    r: 6,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M156 140.307C152.836 140.307 150.252 143.694 150.017 148C150.008 147.747 150 147.504 150 147.24C150 141.858 152.685 137.5 156 137.5C159.315 137.5 162 141.869 162 147.24C162 147.493 162 147.747 161.983 148C161.748 143.694 159.155 140.307 156 140.307Z",
    fill: "#080333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 142,
    r: 6,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M132 140.307C128.836 140.307 126.252 143.694 126.017 148C126.008 147.747 126 147.504 126 147.24C126 141.858 128.685 137.5 132 137.5C135.315 137.5 138 141.869 138 147.24C138 147.493 138 147.747 137.983 148C137.748 143.694 135.155 140.307 132 140.307Z",
    fill: "#080333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 142,
    r: 6,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M108 140.307C104.836 140.307 102.252 143.694 102.017 148C102.008 147.747 102 147.504 102 147.24C102 141.858 104.685 137.5 108 137.5C111.315 137.5 114 141.869 114 147.24C114 147.493 114 147.747 113.983 148C113.748 143.694 111.155 140.307 108 140.307Z",
    fill: "#080333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 163,
    r: 6,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M108 161.307C104.836 161.307 102.252 164.694 102.017 169C102.008 168.747 102 168.504 102 168.24C102 162.858 104.685 158.5 108 158.5C111.315 158.5 114 162.869 114 168.24C114 168.493 114 168.747 113.983 169C113.748 164.694 111.155 161.307 108 161.307Z",
    fill: "#080333"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 163,
    r: 6,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M132 161.307C128.836 161.307 126.252 164.694 126.017 169C126.008 168.747 126 168.504 126 168.24C126 162.858 128.685 158.5 132 158.5C135.315 158.5 138 162.869 138 168.24C138 168.493 138 168.747 137.983 169C137.748 164.694 135.155 161.307 132 161.307Z",
    fill: "#080333"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 184,
    r: 6,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M108 182.307C104.836 182.307 102.252 185.694 102.017 190C102.008 189.747 102 189.504 102 189.24C102 183.858 104.685 179.5 108 179.5C111.315 179.5 114 183.869 114 189.24C114 189.493 114 189.747 113.983 190C113.748 185.694 111.155 182.307 108 182.307Z",
    fill: "#080333"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 184,
    r: 6,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M132 182.307C128.836 182.307 126.252 185.694 126.017 190C126.008 189.747 126 189.504 126 189.24C126 183.858 128.685 179.5 132 179.5C135.315 179.5 138 183.869 138 189.24C138 189.493 138 189.747 137.983 190C137.748 185.694 135.155 182.307 132 182.307Z",
    fill: "#080333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M145.5 117.984C145.5 116.129 145.911 114.668 146.733 113.601C147.568 112.534 148.907 112 150.75 112C152.593 112 153.926 112.534 154.748 113.601C155.583 114.668 156 116.129 156 117.984C156 119.86 155.583 121.332 154.748 122.399C153.926 123.466 152.593 124 150.75 124C148.907 124 147.568 123.466 146.733 122.399C145.911 121.332 145.5 119.86 145.5 117.984ZM152.861 117.984C152.861 116.895 152.724 116.059 152.45 115.477C152.176 114.884 151.609 114.588 150.75 114.588C149.891 114.588 149.324 114.884 149.05 115.477C148.776 116.059 148.639 116.895 148.639 117.984C148.639 118.717 148.689 119.326 148.788 119.811C148.888 120.286 149.087 120.674 149.386 120.976C149.698 121.267 150.152 121.412 150.75 121.412C151.348 121.412 151.796 121.267 152.095 120.976C152.407 120.674 152.612 120.286 152.712 119.811C152.811 119.326 152.861 118.717 152.861 117.984Z",
    fill: "#080333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M156 161.307C152.836 161.307 150.252 164.694 150.017 169C150.008 168.747 150 168.504 150 168.24C150 162.858 152.685 158.5 156 158.5C159.315 158.5 162 162.869 162 168.24C162 168.493 162 168.747 161.983 169C161.748 164.694 159.155 161.307 156 161.307Z",
    fill: "#080333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 139,
    width: 61,
    height: 61,
    rx: 4,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169 188L216 188",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M178.68 165.676L186.527 157.829L192.804 164.106L204.574 152.336",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.945 151.555H204.577H205.361V160.971",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M195.941 170.391H189.663C188.797 170.391 188.094 170.838 188.094 171.389V180.377C188.094 180.929 188.797 181.376 189.663 181.376H195.941C196.807 181.376 197.51 180.929 197.51 180.377V171.389C197.51 170.838 196.807 170.391 195.941 170.391Z",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.112 171.953H170.835C169.969 171.953 169.266 172.556 169.266 173.298V180.024C169.266 180.767 169.969 181.369 170.835 181.369H177.112C177.979 181.369 178.682 180.767 178.682 180.024V173.298C178.682 172.556 177.979 171.953 177.112 171.953Z",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M214.777 167.25H208.499C207.633 167.25 206.93 167.672 206.93 168.192V180.433C206.93 180.952 207.633 181.374 208.499 181.374H214.777C215.643 181.374 216.346 180.952 216.346 180.433V168.192C216.346 167.672 215.643 167.25 214.777 167.25Z",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M223.57 140H162.57V146H223.57V140Z",
    fill: "#080333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M223.57 192H162.57V199H223.57V192Z",
    fill: "#080333"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M72 142.117V197C72 198.105 72.8954 199 74 199H76.5H81H85.5H90H94.5H99H103H106C107.105 199 108 198.105 108 197V142.117C108 140.125 105.227 139.637 104.547 141.509C104.081 142.794 102.4 143.095 101.516 142.052L100.526 140.883C99.7271 139.94 98.2729 139.94 97.474 140.883L96.026 142.592C95.2271 143.535 93.7729 143.535 92.974 142.592L91.526 140.883C90.7271 139.94 89.2729 139.94 88.474 140.883L87.026 142.592C86.2271 143.535 84.7729 143.535 83.974 142.592L82.526 140.883C81.7271 139.94 80.2729 139.94 79.474 140.883L78.4836 142.052C77.6 143.095 75.9192 142.794 75.4527 141.509C74.7729 139.637 72 140.125 72 142.117Z",
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M108 194H73V198H108V194Z",
    fill: "#080333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78 159L91.25 159",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78 153L102 153",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99 159H102",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78 165L91.25 165",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M99 165H102",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78 171L91.25 171",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M99 171H102",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78 177L91.25 177",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M99 177H102",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M78 183L91.25 183",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M99 183H102",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99 189H102",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M108 147V140L103 142L99 139.5L94.5 142L90 140L85.5 142L81 139.5L77.5 142L72 140V147H108Z",
    fill: "#080333"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying glass"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.039 144.383L146.278 148.864L167.237 185.166C168.341 187.079 170.788 187.734 172.701 186.63L173.534 186.149C175.447 185.044 176.103 182.598 174.998 180.685L154.039 144.383Z",
    fill: "#795AF7",
    stroke: "#000917",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.039 144.383L146.278 148.864L153.165 160.794L160.927 156.313L154.039 144.383Z",
    fill: "#E7F0FE",
    stroke: "#000917",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M146.431 149.457L154.516 144.789L156.778 148.708L148.693 153.376L146.431 149.457Z",
    fill: "#080333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.309 132.859C162.86 119.605 154.995 105.982 141.741 102.43C128.487 98.879 114.863 106.745 111.312 119.999C107.76 133.253 115.626 146.876 128.88 150.428C142.134 153.979 155.758 146.114 159.309 132.859ZM152.8 130.858C155.457 120.944 149.882 110.836 140.349 108.281C130.816 105.727 120.934 111.693 118.277 121.608C115.621 131.522 121.196 141.631 130.729 144.185C140.262 146.739 150.144 140.773 152.8 130.858Z",
    fill: "#E8E8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.129 100.982C156.183 104.747 164.524 119.193 160.758 133.248L157.86 132.471C161.197 120.017 153.807 107.216 141.353 103.879L142.129 100.982ZM109.863 119.61C113.629 105.556 128.075 97.2157 142.129 100.982L141.353 103.879C128.899 100.542 116.098 107.933 112.761 120.387L109.863 119.61ZM128.492 151.877C114.437 148.111 106.097 133.665 109.863 119.61L112.761 120.387C109.424 132.841 116.814 145.642 129.268 148.979L128.492 151.877ZM160.758 133.248C156.992 147.302 142.546 155.642 128.492 151.877L129.268 148.979C141.722 152.316 154.523 144.925 157.86 132.471L160.758 133.248ZM140.737 106.832C151.124 109.615 157.106 120.586 154.249 131.247L151.352 130.47C153.808 121.302 148.641 112.056 139.961 109.73L140.737 106.832ZM116.829 121.22C119.685 110.559 130.351 104.049 140.737 106.832L139.961 109.73C131.281 107.404 122.183 112.828 119.726 121.996L116.829 121.22ZM130.341 145.634C119.954 142.851 113.972 131.88 116.829 121.22L119.726 121.996C117.27 131.165 122.437 140.41 131.117 142.736L130.341 145.634ZM154.249 131.247C151.393 141.907 140.727 148.417 130.341 145.634L131.117 142.736C139.797 145.062 148.895 139.639 151.352 130.47L154.249 131.247Z",
    fill: "#000917"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 135.543,
    cy: 126.238,
    rx: 17.101,
    ry: 16.4433,
    transform: "rotate(-75 135.543 126.238)",
    fill: "#E7F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M117.283 121.341C120.6 108.963 130.437 100.761 139.744 102.269C139.219 102.094 138.717 101.924 138.162 101.775C126.837 98.7406 114.851 106.79 111.376 119.759C107.901 132.728 114.279 145.698 125.582 148.726C126.115 148.869 126.648 149.012 127.198 149.089C118.385 145.742 113.975 133.687 117.283 121.341Z",
    fill: "#000917"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M123.353 122.967C125.89 113.501 132.417 106.962 138.268 107.776C137.941 107.662 137.629 107.551 137.282 107.458C130.204 105.562 122.319 112.06 119.662 121.978C117.004 131.895 120.597 141.469 127.661 143.362C127.995 143.451 128.328 143.541 128.674 143.58C123.2 141.359 120.824 132.407 123.353 122.967Z",
    fill: "#000917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.179 113.624C132.078 111.989 125.807 115.61 124.172 121.711",
    stroke: "#000917",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.7s",
    repeatCount: "indefinite",
    path: "M-10,-5 m -10, 0 a 10,10 0 1,0 20,0 a 10,10 0 1,0 -20,0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19109_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.94,
    height: 18.71,
    fill: "white",
    transform: "translate(7.26562 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19109_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.94,
    height: 18.71,
    fill: "white",
    transform: "translate(156.266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_19109_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.6809,
    height: 9,
    fill: "white",
    transform: "translate(90.2656 42)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_19109_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.6809,
    height: 9,
    fill: "white",
    transform: "translate(239.266 27)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_19109_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9333,
    height: 16,
    fill: "white",
    transform: "translate(249.266 78)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_19109_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9333,
    height: 16,
    fill: "white",
    transform: "translate(248.266 161)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_19109_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9333,
    height: 16,
    fill: "white",
    transform: "translate(0.265625 95)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_19109_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9333,
    height: 16,
    fill: "white",
    transform: "translate(0.265625 180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_19109_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.46667,
    height: 8,
    fill: "white",
    transform: "translate(15.2656 136)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_19109_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.46667,
    height: 8,
    fill: "white",
    transform: "translate(278.266 113)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSellLoader);
export default __webpack_public_path__ + "static/media/x-sell-loader.0b95882210a703c2a412318175fbc23b.svg";
export { ForwardRef as ReactComponent };